import React from "react";
import "./Home.css";
import arrow from "./arrow.svg";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      <h1>Hello, I'm Tanveer M Sayem</h1>
      <h2>I'm a full-stack web developer</h2>
      <Link className="link" to="/projects">
        <button className="home-btn">
          <h3 className="homeBtn">View my work</h3>
          <img src={arrow} alt="arrow" />
        </button>
      </Link>
    </div>
  );
}

export default Home;
